"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
Wrapper that will auto-number any child NumberedBox components
*/
function AutoNumberedBoxes(_ref) {
  var children = _ref.children,
      id = _ref.id,
      start = _ref.start;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      '--st-numberbox-counter': id,
      counterReset: "var(--st-numberbox-counter) " + (start - 1)
    }
  }, children);
}

AutoNumberedBoxes.propTypes = {
  /** string to use as ID for counter */
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,

  /** start counter at this number */
  start: _propTypes["default"].number
};
AutoNumberedBoxes.defaultProps = {
  start: 1
};
var _default = AutoNumberedBoxes;
exports["default"] = _default;